import { useQuery } from '@tanstack/react-query';
import { fetchOutgoingTransactionById } from '@/api/transactions';
import type { OutgoingTransactionDetail } from '@/api/transactions/types';

export const outgoingTransactionDetailKeys = {
  detail: (txId: string) => ['outgoing-transaction-detail', txId] as const,
};

function normalizeDetail(raw: unknown): OutgoingTransactionDetail | null {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw as Record<string, unknown>;
  // API may wrap in { data: ... } or return directly
  const d = (obj.data ?? obj) as Record<string, unknown>;
  if (!d?.id) return null;
  return d as unknown as OutgoingTransactionDetail;
}

export function useOutgoingTransactionDetail(txId: string) {
  return useQuery({
    queryKey: outgoingTransactionDetailKeys.detail(txId),
    queryFn: async () => {
      const res = await fetchOutgoingTransactionById(txId);
      return normalizeDetail(res);
    },
    enabled: !!txId,
  });
}
